/**
 * @author Matěj Grabovský <matej.grabovsky@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import objectHash from 'object-hash';

/**
 * Třídá pro hashování informací určených ke generování otisku zařízení.
 */
class FingerprintHasher {
  /**
   * Hashuje JavaScriptovou hodnotu.
   * @param {*} value Hodnota, která se má hashovat.
   * @returns {string} Řetězec hexadecimálních číslic.
   */
  hashObject(value) {
    return objectHash(value, {
      algorithm: 'sha1',
      encoding: 'hex',
      // Nezahrnují se funkce.
      respectFunctionNames: false,
      respectFunctionProperties: false,
      // Nezahrnují se speciální vlastnosti jako `prototype` apod.
      respectType: false
    });
  }
}

export default FingerprintHasher;
